import React, { forwardRef } from 'react';
import * as Styled from './styled';

interface MapButtonProps {
  onClick: () => void;
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  disabled: boolean;
  'data-gtm': string;
}

const MapButton = forwardRef<HTMLButtonElement, MapButtonProps>(
  (
    { onClick, title, icon, children, disabled, 'data-gtm': dataGtm },
    ref
  ): React.ReactElement => {
    return (
      <Styled.MapButton
        onClick={onClick}
        title={title}
        data-gtm={dataGtm}
        disabled={disabled}
        ref={ref}
      >
        <Styled.LabelWrapper>{children}</Styled.LabelWrapper>
        <Styled.IconWrapper>{icon}</Styled.IconWrapper>
      </Styled.MapButton>
    );
  }
);

export default MapButton;
